import { SortCards } from "./SortCards";
import { SortCategories } from "./SortCategories";

export const SortCommands = {
    cards: new SortCards(),
    categories: new SortCategories()
}